module.exports = __webpack_public_path__ + "media/SAF-1000-2_Ares_BEC_2025.5422afa3.mp4";